export default "__VITE_ASSET__ZDYtt5FG__"